import React from 'react'
import { useForm, Form, Field } from '../../form'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import store from '../../store'
import { goToReminder } from '../../actions'
import { useDispatch } from 'react-redux'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import { Snackbar } from '@material-ui/core'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import { industryTaxCardValidate } from '../../containers/validate'
import { FILE_MAX_SIZE } from '../../constants'
import ValttiImage from './valttiImage.component'
import ValttiImageMobile from './valttiImageMobile.component'
import mobileView from '../../utils/mobile.utils'

/**
 * This part is about 'Construction/ shipbuilding industry Valtticard - KAS.335'
 *
 * @author Huong Nguyen
 */

class ValttiCardComponent extends React.Component {
  componentDidMount() {
    this.props.getIndustryTaxCard()
  }

  render() {
    return <ValttiCard {...this.props} />
  }
}

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    width: '100%'
  },
  resize: {
    fontSize: '14px'
  },
  checkbox: {
    fontSize: '15px',
    fontWeight: '500',
    color: '#808080'
  },
  userInfoContainer: {
    maxHeight: '480px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '16px',
    padding: '0px 30px'
  },
  userInfoField: {
    width: '30%',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  deliveryInfoContainer: {
    maxHeight: '350px',
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    padding: '0px 30px',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  imageFieldContainer: {
    maxHeight: '480px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '16px',
    padding: '0px 30px',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      maxHeight: '700px'
    }
  }
})

export const defaultValues = {
  lastname: '',
  firstname: '',
  phone: '',
  ssn: '',
  tax_num: '',
  address: '',
  unit: '',
  zip_code: '',
  city: '',
  inputImage: '',
  construction: true,
  shipbuilding: false
}

const ValttiCard = ({
  t,
  classes,
  shipbuildingTaxCard,
  taxInfo,
  taxFormValues,
  isSnackbar,
  isFailedSnackbar,
  closeSnackbar
}) => {
  // KAS-335 image uploaded
  const [picture, setPicture] = React.useState('')
  // set form disabled after submit
  const [isDisabled, setIsDisabled] = React.useState(false)
  // show warning dialog before submitting tax card
  const [isDialog, setIsDialog] = React.useState(false)
  // Picture helptext
  const [helpertext, setHelpertext] = React.useState('')
  const dispatch = useDispatch()

  const form = useForm({
    name: 'taxArea',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false,
    validator: industryTaxCardValidate
  })

  const { control, clearErrors } = form

  function onSubmit(values) {
    if (values.inputImage === undefined) {
      setHelpertext(t('validation.pako'))
    } else {
      dispatch(goToReminder(values))
      setIsDialog(true)
    }
  }

  // Preview image when it is uploaded
  const imageHandler = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    const file = e.target.files[0]
    if (file !== undefined && file.size >= FILE_MAX_SIZE) {
      // Photo size under 5MB
      setHelpertext(t('taxArea.msg3'))
      setPicture('')
      e.target.value = ''
    } else {
      reader.onload = () => {
        if (reader.readyState === 2) {
          setPicture(reader.result)
        }
      }
      reader.readAsDataURL(file)
      setHelpertext('')
    }
  }

  // Show picture after industry tax card is sent
  React.useEffect(() => {
    if (taxInfo?.path) {
      setPicture(taxInfo.path)
    } else {
      setPicture('')
    }
  }, [taxInfo, setPicture])

  // User details data. when use data at profile is not filled the mandatory, the industry tax card will be disabled
  const userData = store.getState().profile.userData
  const phone = userData.phone
  const ssn = userData.ssn

  const lang = store.getState().language.lang

  const isMobile = window.innerWidth <= 768

  // Disable condition vatiable for the form's field
  const isDisabledField =
    phone === null ||
    phone === '' ||
    ssn === null ||
    ssn === '' ||
    taxInfo?.path ||
    isDisabled
      ? true
      : false

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="dashboard-content-header">
            <h1>{t('taxArea.h1')}</h1>
          </div>
          {/* KAS-351 Valtti card UI fix */}
          <div className="col-xs-12 col-sm-12 col-lg-12">
            <div
              className="panel panel-default red"
              style={{ textAlign: 'center', padding: '0px', marginBottom: 0 }}
            >
              <b>
                <p style={{ marginBottom: '0px' }}>{t('taxArea.note1')}</p>
                <p>{t('taxArea.note2')}</p>
              </b>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="dashboard-content-header">
            <Form {...form}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: mobileView && 'column',
                  paddingLeft: mobileView ? 32 : 10,
                  justifyContent: !mobileView && 'center'
                }}
              >
                <div>
                  <Field
                    name="construction"
                    label={t('taxArea.label10')}
                    inputType="checkbox"
                    className={classes.checkbox}
                    control={control}
                    disabled={isDisabledField}
                    errorStyle={{ fontSize: '12px' }}
                  />
                </div>
                <div>
                  <Field
                    name="shipbuilding"
                    label={t('taxArea.label11')}
                    inputType="checkbox"
                    className={classes.checkbox}
                    control={control}
                    disabled={isDisabledField}
                    onChange={(e) => {
                      if (e.target.checked) {
                        clearErrors(['construction'])
                      }
                    }}
                  />
                </div>
              </div>
              <div
                className="col-xs-12 col-sm-12 col-lg-12"
                style={{ padding: 0 }}
              >
                <div
                  className="panel panel-default"
                  style={{ marginBottom: 0, paddingBottom: 20 }}
                >
                  <div className="panel-heading" style={{ width: '100%' }}>
                    <h3 className="panel-title">{t('taxArea.title1')}</h3>
                  </div>
                  <div className={classNames(classes.userInfoContainer)}>
                    <div className={classNames(classes.userInfoField)}>
                      <Field
                        name="lastname"
                        label={t('taxArea.label1')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                    <div className={classNames(classes.userInfoField)}>
                      <Field
                        name="firstname"
                        label={t('taxArea.label2')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                    <div className={classNames(classes.userInfoField)}>
                      <Field
                        name="phone"
                        label={t('taxArea.label3')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                    <div className={classNames(classes.userInfoField)}>
                      <Field
                        name="ssn"
                        label={t('taxArea.label4')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={true}
                      />
                    </div>
                    <div className={classNames(classes.userInfoField)}>
                      <Field
                        name="tax_num"
                        label={t('taxArea.label5')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="col-xs-12 col-sm-12 col-lg-12"
                style={{ padding: 0 }}
              >
                <div
                  className="panel panel-default"
                  style={{ marginBottom: 0, paddingBottom: 20 }}
                >
                  <div className="panel-heading">
                    <h3 className="panel-title">{t('taxArea.title2')}</h3>
                  </div>
                  <div className={classNames(classes.deliveryInfoContainer)}>
                    <div style={{ width: !isMobile && '35%' }}>
                      <Field
                        name="address"
                        label={t('taxArea.label6')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                    <div style={{ width: !isMobile && '20%' }}>
                      <Field
                        name="unit"
                        label={t('taxArea.label7')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                    <div style={{ width: !isMobile && '20%' }}>
                      <Field
                        name="zip_code"
                        label={t('taxArea.label8')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                    <div style={{ width: !isMobile && '35%' }}>
                      <Field
                        name="city"
                        label={t('taxArea.label9')}
                        inputType="textfield"
                        control={control}
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        disabled={isDisabledField}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {isMobile ? (
                <ValttiImageMobile
                  t={t}
                  isDisabledField={isDisabledField}
                  picture={picture}
                  imageHandler={imageHandler}
                  helpertext={helpertext}
                  classes={classes}
                  control={control}
                  isMobile={isMobile}
                />
              ) : (
                <ValttiImage
                  t={t}
                  isDisabledField={isDisabledField}
                  picture={picture}
                  imageHandler={imageHandler}
                  helpertext={helpertext}
                  classes={classes}
                  control={control}
                  isMobile={isMobile}
                />
              )}

              <div>
                <div style={{ paddingLeft: '15px' }}>
                  <b>
                    <p>
                      {t('taxArea.p8')}
                      <a
                        style={{ fontWeight: 'normal' }}
                        href={
                          lang === 'fi'
                            ? 'https://www.vastuugroup.fi/fi-fi/palvelut/valttikortti'
                            : 'https://www.vastuugroup.fi/fi-en/our-services/valtticard'
                        }
                        target="_blank"
                      >
                        {t('taxArea.valtticardlink')}
                      </a>
                    </p>
                  </b>
                </div>
                <div
                  className="pull-right"
                  style={{ paddingRight: '15px', paddingBottom: '15px' }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={isDisabledField}
                  >
                    {t('taxArea.btn2')}
                  </Button>
                </div>
              </div>
              <Dialog
                open={isDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  <span style={{ fontSize: '20px' }}>{t('taxArea.p9')}</span>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <span style={{ fontSize: '14px' }}>{t('taxArea.p10')}</span>
                  </DialogContentText>
                  <DialogActions style={{ paddingBottom: 10 }}>
                    <div className="pull-right">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setIsDialog(false)
                        }}
                      >
                        {t('taxArea.btn3')}
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          shipbuildingTaxCard(taxFormValues)
                          setIsDialog(false)
                          setIsDisabled(true)
                        }}
                      >
                        {t('taxArea.btn4')}
                      </Button>
                    </div>
                  </DialogActions>
                </DialogContent>
              </Dialog>
            </Form>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={isSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                variant="success"
                message={t('taxArea.msg1')}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={isFailedSnackbar}
              autoHideDuration={4000}
              onClose={() => {
                closeSnackbar()
              }}
            >
              <MySnackbarContentWrapper
                variant="error"
                message={t('taxArea.msg2')}
              />
            </Snackbar>
          </div>
        </div>
      </div>
    </div>
  )
}

ValttiCardComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ValttiCardComponent)
